async function newUpdateProductData (uniqueHandles) {
    const productGiftDataReq = await Promise.all(Array.from(uniqueHandles).map(handle => fetch(window.Shopify.routes.root + `products/${handle}.js`)));
    const productGiftDataRes = await Promise.all(productGiftDataReq.map(req => req.json()));
    return new Map(productGiftDataRes.map(product => {
        window.tlProductBundle.productIdMapData.set(String(product.id), product);
        const firstAvailableVariant = product?.variants
            .sort((a, b) => b.price - a.price)
            .find((v) => v.available);
        localStorage.setItem(`salepify-bundle-${firstAvailableVariant.id}`, JSON.stringify(product));
        return [product.handle, product];
    }));
}

const intervalIdSalepify = setInterval(() => {
    if (window.tlProductBundle) {
        clearInterval(intervalIdSalepify);
        window.tlProductBundle.updateProductData = newUpdateProductData;
        console.log("custom salepify bundle done");
    }
}, 100);

setTimeout(() => {
    clearInterval(intervalIdSalepify);
}, 3000)